<template>
  <button type="button" class="btn btn-link text-primary text-decoration-none pl-0 pt-0 mt-1 mb-1" data-toggle="modal" :data-target="modalTarget">
    <i class="fas fa-plus mr-1"></i>
    <slot></slot>
  </button>
</template>

<script>
  export default {
    props: {
      modalTarget: String
    }
  }
</script>
